/* tslint:disable */
/* eslint-disable */
/**
 * Vipps ePayment Internal API
 * The Vipps ePayment Internal api
 *
 * The version of the OpenAPI document: 0.9.0
 * Contact: teamecom@vipps.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CardPagePaymentResult,
    CardPagePaymentResultFromJSON,
    CardPagePaymentResultToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models';

export interface AbortCardPaymentRequest {
    ocpApimSubscriptionKey: string;
}

export interface GetPaymentDetailsRequest {
    ocpApimSubscriptionKey: string;
}

/**
 * 
 */
export class EpaymentApi extends runtime.BaseAPI {

    /**
     */
    async abortCardPaymentRaw(requestParameters: AbortCardPaymentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.ocpApimSubscriptionKey === null || requestParameters.ocpApimSubscriptionKey === undefined) {
            throw new runtime.RequiredError('ocpApimSubscriptionKey','Required parameter requestParameters.ocpApimSubscriptionKey was null or undefined when calling abortCardPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.ocpApimSubscriptionKey !== undefined && requestParameters.ocpApimSubscriptionKey !== null) {
            headerParameters['Ocp-Apim-Subscription-Key'] = String(requestParameters.ocpApimSubscriptionKey);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/v1/card-page/Payments/abort`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async abortCardPayment(requestParameters: AbortCardPaymentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<void> {
        await this.abortCardPaymentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getPaymentDetailsRaw(requestParameters: GetPaymentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CardPagePaymentResult>> {
        if (requestParameters.ocpApimSubscriptionKey === null || requestParameters.ocpApimSubscriptionKey === undefined) {
            throw new runtime.RequiredError('ocpApimSubscriptionKey','Required parameter requestParameters.ocpApimSubscriptionKey was null or undefined when calling getPaymentDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.ocpApimSubscriptionKey !== undefined && requestParameters.ocpApimSubscriptionKey !== null) {
            headerParameters['Ocp-Apim-Subscription-Key'] = String(requestParameters.ocpApimSubscriptionKey);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/v1/card-page/Payments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CardPagePaymentResultFromJSON(jsonValue));
    }

    /**
     */
    async getPaymentDetails(requestParameters: GetPaymentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CardPagePaymentResult> {
        const response = await this.getPaymentDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
